export const coursesSetupDetailsData = [
    { 
        title: 'Create Your First Course', 
        content: 'Get started on creating your course by adding videos, audio files, PDFs and embedding content from any platform into your course lessons.',
    },
    { 
        title: 'Publish Your Course', 
        content: 'Publish your course to your community and create a community-based learning experience around your expertise.',
    },
];
